<template>
  <div
    v-show="show"
    class="app-integration__left-menu-alert"
  >
    <router-link
      :to="{ name: 'DoctorAppIntegration' }"
      tag="div"
    >
      Novo: Receba mais pacientes!
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'AppIntegrationAlert',

  props: {
    show: {
      type: Boolean,
      required: true,
      default: () => false
    },

    parentElement: {
      type: String,
      required: true,
      default: () => ''
    }
  },

  data () {
    return {
      showAlert: false
    }
  },

  watch: {
    show: {
      deep: false,
      immediate: true,
      handler () {
        this.showAlert = this.show
      }
    },

    showAlert: {
      deep: false,
      immediate: false,
      handler () {
        if (this.showAlert) {
          this.displayAlert()
        }
      }
    }
  },

  methods: {
    setAlertPosition () {
      const alert = document.querySelector('.app-integration__left-menu-alert') || null
      const parent = document.querySelector(`.${this.parentElement}`) || null
      if (alert && parent) {
        const parentViewportOffset = parent.getBoundingClientRect()
        const top = parentViewportOffset.top + parent.offsetHeight + 13
        const left = parentViewportOffset.left

        alert.style.top = `${top}px`
        alert.style.left = `${left}px`
      }
    },

    displayAlert () {
      this.$nextTick(() => {
        this.setAlertPosition()
        const alert = document.querySelector('.app-integration__left-menu-alert') || null
        if (alert) alert.style.display = 'block'
      })
    },

    hideAlert () {
      this.showAlert = false
    }
  }
}
</script>
